import {AfterViewInit, Component, inject} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Direction } from '@angular/cdk/bidi';
import { GoogleAnalyticsService } from './services/analytics/google-analytics.service';
import { ActivatedRoute } from '@angular/router';
import { CookieManagerComponent } from './cookie-manager/cookie-manager.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [CookieManagerComponent]
})
export class AppComponent implements AfterViewInit {
  private readonly translateService = inject(TranslateService);
  private readonly route = inject(ActivatedRoute);

  title = 'DCP-cookie-manager';
  direction = 'ltr' as Direction;

  ngAfterViewInit(): void {
    setTimeout( () => {
      if (this.translateService.getFallbackLang() === 'ar') {
        this.direction = 'rtl' as Direction;
      }
    }, 500);

    this.route.queryParamMap.subscribe((query: any) => {
      if (query.params.ssid) {
        const version = query.params.version;
        const lang = query.params.lang;
        const ssid = query.params.ssid;

        GoogleAnalyticsService.setCustomDimension('app_lang', lang);
        GoogleAnalyticsService.setCustomDimension('app_version', version);
        GoogleAnalyticsService.setCustomDimension('app_ssid', ssid);
        GoogleAnalyticsService.sendEvent({ event: 'privacy', content_name: 'display popin' });
      }
    });
  }
}
